import {Alert, Badge, Modal} from 'react-bootstrap'
import {INodeNotePolicy} from '../../../../types/policiesApi'
import moment from 'moment'
import {useEffect, useState} from 'react'

export const ContentNotes = ({notes, compact}: {notes: INodeNotePolicy[], compact?: boolean}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null)

  // Agregar event listeners a las imágenes después de renderizar
  useEffect(() => {
    const handleImageClick = (e: Event) => {
      const target = e.target as HTMLImageElement
      if (target.tagName === 'IMG' && target.closest('.note-content')) {
        e.preventDefault()
        setSelectedImage(target.src)
      }
    }

    // Agregar event listeners a todas las imágenes en note-content
    const images = document.querySelectorAll('.note-content img')
    images.forEach((img) => {
      img.addEventListener('click', handleImageClick)
      // Agregar cursor pointer para indicar que es clickeable
      ;(img as HTMLElement).style.cursor = 'pointer'
    })

    return () => {
      images.forEach((img) => {
        img.removeEventListener('click', handleImageClick)
      })
    }
  }, [notes])

  return (
    <>
      <style>{`
        .note-content img {
          max-width: 100%;
          height: auto;
          object-fit: contain;
          border-radius: 4px;
          cursor: pointer;
          transition: opacity 0.2s;
        }
        .note-content img:hover {
          opacity: 0.8;
        }
        .note-content iframe,
        .note-content video {
          max-width: 100%;
          height: auto;
        }
      `}</style>
      <div className='d-flex flex-column gap-4'>
      {notes.length === 0 && (
        <Alert variant='primary'>
          <i className='fa fa-exclamation-circle me-1' style={{color: 'inherit'}} />
          There are no notes created for this policy yet.
        </Alert>
      )}
      {notes.map((note) => (
        <Alert
          className={compact ? 'text-wrap' : undefined}
          style={{ width: compact ? '100%' : 'max-content', maxWidth: compact ? '100%' : undefined }}
          key={note.id}
          variant={note.urgent ? 'danger' : 'success'}
        >
          <div className='d-flex align-items-start gap-3'>
            <div className='d-flex align-items-start text-primary gap-2'>
              <span className='avatar' style={{textTransform: 'uppercase', fontWeight: 'bolder'}}>
                {note.user.firstName[0]}
              </span>
              <p className='d-flex flex-column'>
                <span className='fw-bold m-0 p-0'>
                  {note.user.firstName} {note.user.lastName}
                </span>
                <small className='d-block m-0 p-0'>
                  {moment(note.created).format('MMM DD, YYYY hh:mm A')}
                </small>
              </p>
            </div>
            {note.urgent && <Badge bg='danger'>Urgent</Badge>}
          </div>
          <div className='text-dark'>
            <div
              dangerouslySetInnerHTML={{__html: note.comments}}
              style={{
                maxWidth: '100%',
                overflow: 'hidden',
              }}
              className='note-content'
            />
          </div>
        </Alert>
      ))}
      </div>

      {/* Modal para mostrar imagen en grande */}
      <Modal
        show={selectedImage !== null}
        onHide={() => setSelectedImage(null)}
        size='xl'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-0'>
          {selectedImage && (
            <img
              src={selectedImage}
              alt='Preview'
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '80vh',
                objectFit: 'contain',
              }}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  )
}
